var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "weforsys-table-box", class: [_vm.config.__config__.type] },
    [
      _vm.config.__config__.showTitle && _vm.config.__config__.label
        ? _c("div", { staticClass: "Weforsys-common-title" }, [
            _c("h2", [_vm._v(_vm._s(_vm.config.__config__.label))]),
          ])
        : _vm._e(),
      _c(
        "el-table",
        _vm._b(
          {
            staticClass: "Weforsys-common-table",
            attrs: {
              data: _vm.tableFormData,
              "show-summary": _vm.config["show-summary"],
              "summary-method": _vm.getTableSummaries,
              size: "mini",
            },
            on: { "cell-click": _vm.focusInput },
          },
          "el-table",
          _vm.config.tableConf || {},
          false
        ),
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              width: "50",
              align: "center",
              label: "序号",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "row-action" }, [
                      _c(
                        "span",
                        {
                          staticClass: "index",
                          class: { "btn-disabled": _vm.disabled },
                        },
                        [_vm._v(_vm._s(scope.$index + 1))]
                      ),
                      _c("i", {
                        staticClass: "el-icon-delete delete-btn",
                        on: {
                          click: function ($event) {
                            return _vm.removeRow(scope.$index)
                          },
                        },
                      }),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.tableData, function (head, cindex) {
            return _c(
              "el-table-column",
              {
                key: head.__config__.formId,
                attrs: {
                  "show-overflow-tooltip": "",
                  "min-width": head["min-width"],
                  prop: head.__vModel__,
                  width: head.__config__.columnWidth,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          ["select", "checkbox", "radio"].includes(
                            head.__config__.weforsysKey
                          )
                            ? [
                                _c(
                                  "el-select",
                                  _vm._b(
                                    {
                                      attrs: {
                                        filterable: "",
                                        rowIndex: scope.$index,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onFormDataChange(
                                            scope.$index,
                                            cindex,
                                            "el-select"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.tableFormData[scope.$index][
                                            cindex
                                          ].value,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tableFormData[scope.$index][
                                              cindex
                                            ],
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "tableFormData[scope.$index][cindex].value",
                                      },
                                    },
                                    "el-select",
                                    _vm.getConfById(head.__config__.formId),
                                    false
                                  ),
                                  _vm._l(
                                    head.__slot__.options,
                                    function (opt, oindex) {
                                      return _c("el-option", {
                                        key: oindex,
                                        attrs: {
                                          label:
                                            opt[head.__config__.props.label],
                                          value:
                                            opt[head.__config__.props.value],
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            : head.__config__.weforsysKey === "comInput"
                            ? [
                                _c(
                                  "el-input",
                                  _vm._b(
                                    {
                                      attrs: { rowIndex: scope.$index },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onFormDataChange(
                                            scope.$index,
                                            cindex,
                                            "el-input"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.tableFormData[scope.$index][
                                            cindex
                                          ].value,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tableFormData[scope.$index][
                                              cindex
                                            ],
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "tableFormData[scope.$index][cindex].value",
                                      },
                                    },
                                    "el-input",
                                    _vm.getConfById(head.__config__.formId),
                                    false
                                  ),
                                  [
                                    head.__slot__
                                      ? [
                                          head.__slot__.prepend
                                            ? _c(
                                                "template",
                                                { slot: "prepend" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      head.__slot__.prepend
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          head.__slot__.append
                                            ? _c(
                                                "template",
                                                { slot: "append" },
                                                [
                                                  _vm._v(
                                                    _vm._s(head.__slot__.append)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _c(
                                head.__config__.tag,
                                _vm._b(
                                  {
                                    tag: "component",
                                    attrs: {
                                      rowIndex: scope.$index,
                                      formData: _vm.formData,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFormDataChange(
                                          scope.$index,
                                          cindex,
                                          head.__config__.tag
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.tableFormData[scope.$index][cindex]
                                          .value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tableFormData[scope.$index][
                                            cindex
                                          ],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "tableFormData[scope.$index][cindex].value",
                                    },
                                  },
                                  "component",
                                  _vm.getConfById(head.__config__.formId),
                                  false
                                )
                              ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.tableFormData[scope.$index][cindex]
                                      .valid,
                                  expression:
                                    "!tableFormData[scope.$index][cindex].valid",
                                },
                              ],
                              staticClass: "error-tip",
                            },
                            [_vm._v("不能为空")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("template", { slot: "header" }, [
                  head.__config__.required
                    ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v("*"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n        " + _vm._s(head.__config__["label"]) + "\n      "
                  ),
                ]),
              ],
              2
            )
          }),
        ],
        2
      ),
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "table-actions", on: { click: _vm.addRow } },
            [
              _c(
                "el-button",
                { attrs: { type: "text", icon: "el-icon-plus" } },
                [_vm._v(_vm._s(_vm.config.actionText))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }